import { DASHBOARD_MESSAGE_CONSTANTS } from '../../translate-messages/ngrx-store/dashboard';
import { API_METHOD_CONSTANTS } from '../core';

export const DASHBOARD_METHOD_CONSTANT = {
   DASHBOARD: 'DASHBOARD',
   DASHBOARD_WIDGET: 'DASHBOARD_WIDGET',
};

export const DASHBOARD_NGRX_CONSTANTS = {

  [DASHBOARD_METHOD_CONSTANT.DASHBOARD]: {
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'createDashboard',
      STATE: 'createDashboard',
      SUCCESS_NOTIFICATION: true,
      TITLE: DASHBOARD_MESSAGE_CONSTANTS.TITLE_DASHBOARD,
      SUCCESS: DASHBOARD_MESSAGE_CONSTANTS.SUCCESS_INSERT_DASHBOARD,
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateDashboard',
      STATE: 'updateDashboard',
      SUCCESS_NOTIFICATION: true,
      API_RESPONSE: 'data',
      TITLE: DASHBOARD_MESSAGE_CONSTANTS.TITLE_DASHBOARD,
      SUCCESS: DASHBOARD_MESSAGE_CONSTANTS.SUCCESS_UPDATE_DASHBOARD,
    },
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getDashboardById',
      STATE: 'getDashboardById',
      SUCCESS_NOTIFICATION: false,
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteDashboard',
      STATE: 'deleteDashboard',
      SUCCESS_NOTIFICATION: true,
      API_RESPONSE: 'data',
      TITLE: DASHBOARD_MESSAGE_CONSTANTS.TITLE_DASHBOARD,
      SUCCESS: DASHBOARD_MESSAGE_CONSTANTS.SUCCESS_DELETE_DASHBOARD,
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getDashboardsPaging',
      STATE: 'getDashboardsPaging',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
  },

  [DASHBOARD_METHOD_CONSTANT.DASHBOARD_WIDGET]: {
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'createDashboardWidget',
      STATE: 'createDashboardWidget',
      SUCCESS_NOTIFICATION: true,
      TITLE: DASHBOARD_MESSAGE_CONSTANTS.TITLE_DASHBOARD_WIDGET,
      SUCCESS: DASHBOARD_MESSAGE_CONSTANTS.SUCCESS_INSERT_DASHBOARD_WIDGET,
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateDashboardWidget',
      STATE: 'updateDashboardWidget',
      SUCCESS_NOTIFICATION: true,
      API_RESPONSE: 'data',
      TITLE: DASHBOARD_MESSAGE_CONSTANTS.TITLE_DASHBOARD_WIDGET,
      SUCCESS: DASHBOARD_MESSAGE_CONSTANTS.SUCCESS_UPDATE_DASHBOARD_WIDGET,
    },
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getDashboardWidgetById',
      STATE: 'getDashboardWidgetById',
      SUCCESS_NOTIFICATION: false,
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteDashboardWidget',
      STATE: 'deleteDashboardWidget',
      SUCCESS_NOTIFICATION: true,
      API_RESPONSE: 'data',
      TITLE: DASHBOARD_MESSAGE_CONSTANTS.TITLE_DASHBOARD_WIDGET,
      SUCCESS: DASHBOARD_MESSAGE_CONSTANTS.SUCCESS_DELETE_DASHBOARD_WIDGET,
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getDashboardsPaging',
      STATE: 'getDashboardsPaging',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
  },

};
